import React from 'react'
import clsx from 'clsx'
//import I18n from 'i18n-js/index.js.erb'
import MultiSelect from '../../Selects/MultiSelect'
import GroupContractBuilderErrors from '../GroupContractBuilderErrors'
class GroupContractBuilderRates extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    var header = I18n.t('code') + ': ' + I18n.t('name')
    var tabClasses = clsx({
      'active': this.props.active_tab == 'rates',
      'tab-pane': true
    })
    var inputs = this.props.all_rates.map(rate => {
      return {
        label_primary: rate.code + ': ' + rate.name + ' (' + (rate.billing_policy_name || '') + ')',
        id: rate.id
      }
    })
    
    return (
      <div className={tabClasses} id="rates">
        { this.renderErrors() }
        <div className="row">
          <div className="col-md-12" style={{marginBottom: 0}}>
            <MultiSelect 
              header_primary={header}
              header_secondary="billing_policy"
              inputs={inputs}
              selected_inputs={this.props.group_contract_rates}
              onChange={this.props.onChangeRates}/>
          </div>
        </div>
      </div>  
    )
  }

  renderErrors() {
    var errors = GroupContractBuilderErrors.rates(this.props.errors);

    if (errors && errors.length) {
      var idx = 0
      var errors = errors.map((error) => {
        idx = idx + 1
        return <li key={error + idx}>{error}</li>
      })

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      )
    }
  }
}
export default GroupContractBuilderRates